import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import RecommendedSection from './components/RecommendedSection';
import RankingSection from './components/RankingSection';
import LatestSection from './components/LatestSection';
import FAQSection from './components/FAQSection';
import { mangaList, faqList } from '@/mocks/manga';

export default function Home() {
  const siteTitle = '韩漫免费漫画在线-好看的韩国漫画-漫画下拉式阅读-韩漫之家';
  const siteDescription = '来到韩漫之家，体验韩漫免费漫画在线的便捷，我们精选好看韩国漫画并支持下拉式阅读模式，让您流畅浏览每一页，仿佛置身专属漫画图书馆中。';
  const siteUrl = 'https://www.hanmanzhijia.com';
  const schemaData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '韩漫之家',
        url: siteUrl,
        description: siteDescription,
        sameAs: [],
      },
      {
        '@type': 'WebSite',
        name: '韩漫之家',
        url: siteUrl,
        description: siteDescription,
        inLanguage: 'zh-CN',
      },
      {
        '@type': 'WebPage',
        name: siteTitle,
        url: siteUrl,
        description: siteDescription,
        isPartOf: { '@id': `${siteUrl}/#website` },
        about: { '@id': `${siteUrl}/#organization` },
        inLanguage: 'zh-CN',
      },
      {
        '@type': 'FAQPage',
        mainEntity: faqList.map(faq => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.answer,
          },
        })),
      },
      {
        '@type': 'ItemList',
        itemListElement: mangaList.slice(0, 10).map((manga, i) => ({
          '@type': 'ListItem',
          position: i + 1,
          item: {
            '@type': 'CreativeWork',
            name: manga.title,
            author: { '@type': 'Person', name: manga.author },
            url: `${siteUrl}/manga/${manga.slug}`,
          },
        })),
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <article>
            <HeroSection />
            <RecommendedSection />
            <RankingSection />
            <LatestSection />
            <FAQSection />
          </article>
        </main>
        <Footer />
      </div>
    </>
  );
}